<template>
    <Page :header="(!isPWA && !isTgApp) ? header[lang_].name : null">
        <template v-slot:body>
            <div class="flex flex-column w-full max-w-30rem">
                <TransferFilter />
                <div v-if="isTgApp" class="flex w-full" style="height:200px"></div>
                <div v-else class="flex w-full" style="height:50px"></div>
            </div>
        </template>
    </Page> 
    <Dialog v-model:visible="email_confirm_dialog" modal :header="popup[lang_].header" :style="{ width: '40vw' }">
        <p>{{popup[lang_].body}}</p>
        <div class="p-d-flex p-jc-end">
            <Button :label="popup[lang_].button" @click="email_confirm_dialog = false" />
        </div>
    </Dialog>
</template>


<script>
import Connect          from '@/assets/js/Connect'
import Helper           from '@/assets/js/Helper'
import TransferFilter   from '@/components/widgets/TransferFilter.vue' 
import Page from '@/components/sides/Page.vue' 
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            header: {
                en: {name: "Create a transfer"} ,
                ru: {name: "Создать перевод"} ,
            }, 
            popup: {
                en: {
                    header: "Confirm your email",
                    body: "Make sure you verify your email so we can send you notifications. Check your email. If you don't see the email, check your Spam folder.",
                    button: "Ok"
                } ,
                ru: {
                    header: "Подтвердите вашу почту",
                    body: "Убедитесь, что вы подтвердили свою электронную почту, чтобы мы могли отправлять вам уведомления. Проверьте свою почту. Если письмо не пришло, проверьте папку Спам.",
                    button: "Хорошо"
                } ,
            },
            email_confirm_dialog: false
        }
    },
    methods: {
        show_email_confirm_dialog() {
            if (this.$route.query.email_confirm) {
                if(this.$route.query.email_confirm) {
                    this.email_confirm_dialog = true
                }
                this.$router.replace('/personal/transfer/create/')
            }
        },
        ...mapActions(['UpdateHeader']),
        updateHeader() {
            this.UpdateHeader({
                title: this.header[this.lang_].name,
                backButton: false,
                backButtonUrl: '/',
                profileButton: false
            });
        }
    },
    components: {
        TransferFilter,
        Page
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
		this.show_email_confirm_dialog()
        this.updateHeader()
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.helper.SetTgAppBackButton(false)
	},
}
</script>